import { useScrollReveal } from '@/hooks/useScrollReveal';

const categories = [
  {
    name: 'Seafood',
    icon: 'ri-anchor-line',
    count: '480+ products',
    desc: 'Prawns, fish fillets, squid, crab — individually quick frozen at peak freshness.',
    accent: 'text-secondary-600',
    bgLight: 'bg-secondary-50',
    borderColor: 'border-secondary-200/60',
    image: 'https://readdy.ai/api/search-image?query=Premium%20frozen%20seafood%20retail%20assortment%20in%20clean%20modern%20packaging%20on%20white%20marble%20surface%2C%20warm%20home%20kitchen%20setting%2C%20appetizing%20fresh%20colors%2C%20lifestyle%20food%20photography%2C%20soft%20natural%20lighting%2C%20high%20detail&width=600&height=400&seq=freshhlock-retail-seafood&orientation=landscape',
  },
  {
    name: 'Meat & Poultry',
    icon: 'ri-restaurant-line',
    count: '320+ products',
    desc: 'Chicken, lamb, duck — standard cuts, graded and frozen for consistent quality.',
    accent: 'text-accent-600',
    bgLight: 'bg-accent-50',
    borderColor: 'border-accent-200/60',
    image: 'https://readdy.ai/api/search-image?query=Premium%20frozen%20chicken%20portions%20and%20meat%20cuts%20in%20modern%20retail%20packaging%20on%20clean%20white%20countertop%2C%20warm%20home%20kitchen%20setting%2C%20appetizing%20presentation%2C%20lifestyle%20food%20photography%2C%20soft%20lighting&width=600&height=400&seq=freshhlock-retail-meat&orientation=landscape',
  },
  {
    name: 'Vegetables',
    icon: 'ri-leaf-line',
    count: '210+ products',
    desc: 'Green peas, sweet corn, mixed vegetables, spinach — frozen within hours of harvest.',
    accent: 'text-secondary-500',
    bgLight: 'bg-secondary-50',
    borderColor: 'border-secondary-200/60',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20frozen%20vegetables%20in%20modern%20retail%20packaging%20on%20light%20kitchen%20surface%2C%20bright%20natural%20green%20colors%2C%20appetizing%20home%20cooking%20setting%2C%20lifestyle%20food%20photography%2C%20clean%20composition%2C%20soft%20daylight&width=600&height=400&seq=freshhlock-retail-veggies&orientation=landscape',
  },
  {
    name: 'Ready-to-Eat',
    icon: 'ri-bowl-line',
    count: '150+ products',
    desc: 'Frozen parathas, snacks, meals, and desserts — heat, serve, enjoy in minutes.',
    accent: 'text-accent-500',
    bgLight: 'bg-accent-50',
    borderColor: 'border-accent-200/60',
    image: 'https://readdy.ai/api/search-image?query=Appetizing%20frozen%20ready%20to%20eat%20Indian%20snacks%20and%20meals%20in%20modern%20packaging%20on%20warm%20kitchen%20counter%2C%20home%20cooking%20lifestyle%20scene%2C%20warm%20golden%20tones%2C%20appetizing%20food%20photography%2C%20soft%20natural%20light&width=600&height=400&seq=freshhlock-retail-rte&orientation=landscape',
  },
];

export default function CategoryShopGrid() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-widest mb-4">
            Shop by Category
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-4">
            Everything Your Kitchen Needs, Frozen at Peak
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto">
            Four curated categories covering everything from everyday cooking to special occasions — all standard-cut, IQF frozen, and delivered cold.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
          {categories.map((cat) => (
            <div
              key={cat.name}
              className={`group relative bg-card-50 rounded-xl overflow-hidden border ${cat.borderColor} shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 cursor-pointer card-animate`}
            >
              <div className="flex flex-col sm:flex-row">
                <div className="w-full sm:w-52 h-44 sm:h-auto overflow-hidden">
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${cat.bgLight} ${cat.accent} mb-3 animate-icon-float icon-hover-pop`}>
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-xl font-bold text-primary-700 mb-1">{cat.name}</h3>
                  <p className="text-sm text-foreground-400 mb-1">{cat.count}</p>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4">{cat.desc}</p>
                  <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent-600 group-hover:text-accent-500 transition-colors">
                    Shop Now
                    <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}